// src/views/NewsView/components/PinnedNews/PinnedNews.styles.tsx
import styled, { css } from 'styled-components';

import { theme } from '@/theme';

export const Wrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(5)};
`;

export const Container = styled.div<{ $columns: number }>`
  max-width: ${({ theme }) => theme.breakpoints.lg};
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing(3)};

  ${theme.media.md.up} {
    ${({ $columns }) => css`
      grid-template-columns: repeat(${$columns}, 1fr);
    `};
  }
`;

export const ArticleCard = styled.div`
  width: 100%;
`;
